import ExclamationSvg from "assets/landing/icons/ExclamantionSvg";
import HeroCard from "./components/HeroCard";
import exclamationIcon from "../../../../assets/landing/exclamantion-icon.svg";
import { useEffect, useRef, useState } from "react";
import { useAnimation, useInView, motion } from "framer-motion";
import { AcceleratedBy } from "./components/AcceleratedBy";

const LandingHeroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
      className="lg:pt-[81px] max-lg:mb-[18.66] mb-[4.142vw] lg:min-h-[calc(100vh-4.93vw-32px-81px-30px-58px)] pb-[5.142vw]"
    >
      <div className="max-lg:px-[3.2vw] px-[4.58vw] w-full flex lg:min-h-[calc(100vh-4.93vw-32px-81px-30px-58px)] flex-col justify-between relative">
        <div>
          {" "}
          <motion.div
            className="absolute z-[1] hidden lg:block top-[-3vw] right-0 pr-[4.58vw] overflow-hidden rounded-[12px] pointer-events-none
             bg-transparent w-[44.33vw] h-[44.33vw]"
            variants={cardVariants}
          >
            <div className="relative w-full h-full overflow-hidden rounded-[12px]">
              <video
                src={`/AGNTXVideoWithTitles_compressed.mp4`}
                className="absolute top-0 left-0 w-[101%] h-[101%] -translate-x-[0.5%] -translate-y-[0.5%] object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onPlaying={() => setVideoReady(true)}
              />
            </div>
          </motion.div>
          {/* TABLET VIDEO */}
          <motion.div
            className="absolute z-[1] hidden sm:block lg:hidden top-[50vw] left-0 right-0 overflow-hidden rounded-[12px] pointer-events-none
                 bg-transparent w-[83.47vw] h-[83.47vw] max-lg:left-[8.53vw] max-lg:right-[8vw]"
            variants={cardVariants}
          >
            <div className="relative w-full h-full overflow-hidden rounded-[12px]">
              <video
                src={`/AGNTXVideoWithTitles_compressed.mp4`}
                className="absolute top-0 left-0 w-[101%] h-[101%] -translate-x-[0.5%] -translate-y-[0.5%] object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onLoadedMetadata={() => {
                  if (videoRef.current) {
                    videoRef.current.currentTime = 1;
                  }
                }}
                onPlaying={() => setVideoReady(true)}
                onPause={() => setVideoReady(false)}
                onEnded={() => setVideoReady(false)}
              />
            </div>
          </motion.div>
          {/* MOBILE VIDEO */}
          <motion.div
            className="absolute z-[1] block sm:hidden top-[50vw] left-0 right-0 overflow-hidden rounded-[12px] pointer-events-none
                 bg-transparent w-[83.47vw] h-[83.47vw] max-lg:left-[8.53vw] max-lg:right-[8vw]"
            variants={cardVariants}
          >
            <div className="relative w-full h-full overflow-hidden rounded-[12px]">
              <video
                src={`/AGNTXVideoWithTitles_mobile.mp4?${Date.now()}`}
                className="absolute top-0 left-0 w-[101%] h-[101%] -translate-x-[0.5%] -translate-y-[0.5%] object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onLoadedMetadata={() => {
                  if (videoRef.current) {
                    videoRef.current.currentTime = 1;
                  }
                }}
                onPlaying={() => setVideoReady(true)}
                onPause={() => setVideoReady(false)}
                onEnded={() => setVideoReady(false)}
              />
            </div>
          </motion.div>
          <motion.div
            className=" mb-[84vw] max-lg:px-[6.13vw] lg:mb-[2.2vw]"
            variants={textVariants}
          >
            <div className="flex flex-col gap-[1.142vw]  max-lg:justify-center mb-[32px] max-lg:mb-[6.4vw]">
              {" "}
              <h1 className="font-medium flex  font-luxora-medium z-10 text-[15.5vw] lg:text-[6.07vw] leading-[1.1] text-black">
                AGNT
                <span>
                  <img
                    src={exclamationIcon}
                    className="w-[10.2vw] h-auto lg:hidden"
                    alt="decoration Exclamation element"
                  />
                  <span className="max-lg:hidden block">
                    <ExclamationSvg />
                  </span>
                </span>
              </h1>
              <p className="font-normal z-10 font-luxora-regular max-lg:text-[6.4vw] text-[2.5vw] leading-[1.1] text-black">
                The $100B Mini App trend is <br /> moving from Telegram to X.
              </p>
            </div>

            <motion.div className="flex items-start " variants={textVariants}>
              <AcceleratedBy />
            </motion.div>
          </motion.div>
        </div>

        {/* Animated Card */}
        <motion.div variants={cardVariants} className="relative z-20">
          <HeroCard />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default LandingHeroSection;
